/* eslint-disable object-shorthand */
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

// add new languages here
const supportedLngs = ["en", "de", "fr"];

console.log("supportedLngs", supportedLngs);

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // comment out fallback to check if any are un-translated or missing keys & LEAVE IN on prod
    fallbackLng: "en",
    debug: import.meta.env.MODE === "development",
    // namespaces declared here will be loaded on app load as they are used across the site in different areas, specific namespaces are loaded at component level
    ns: ["common", "other", "auth", "regex", "countries", "dashboard", "gigs", "onboarding", "security", "settings", "songs", "writers", "album", "tutorial", "playlist"],
    react: {
      useSuspense: true,
      bindI18n: "languageChanged",
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    supportedLngs: supportedLngs,
    // saveMissing is disabled — i18next-http-backend has no endpoint to receive missing keys.
    // Use `pnpm locize:extract` + `pnpm locize:push` to push new keys to Locize instead.
    saveMissing: false,
  });

export default i18n;
